/* Don't Repeat Yourself */
document.addEventListener('DOMContentLoaded', function() {
    psloadMorePosts();
});
// postlisting ajax code
function psloadMorePosts() {
    let page = 2; // Start from the first page
    let isLoading = false;
    let debounceTimeout; // Timeout variable to handle debouncing

    const loadMoreButton = document.getElementById('load-more-btn');
    if (!loadMoreButton) return; // Return if the button doesn't exist
    
    loadMoreButton.addEventListener('click', function() {
        if (isLoading) return; // Prevent multiple requests while loading
        
        // Clear the previous debounce timeout
        clearTimeout(debounceTimeout);

        // Set a new debounce timeout
        debounceTimeout = setTimeout(function() {
            isLoading = true;

            const msperpage = loadMoreButton.getAttribute("data-msperpage");
            const postNotIn = loadMoreButton.getAttribute("data-post_not_in");

            // Dynamically construct the API URL based on the current site URL
            //const apiUrl = `${window.location.origin}/wp-json/ps/v1/pspostlisting`;
			var apiUrl = window.location.hostname === 'localhost' ? 'http://localhost/work/sellafield/wordpress/wp-json/ps/v1/pspostlisting' : '/wp-json/ps/v1/pspostlisting';

            const data = {
                page: page,
                mpperpage: msperpage,
                post_not_in: postNotIn // Make sure this is serialized on the backend
            };

            fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
            .then(response => response.json())
            .then(json_html => {
                if (json_html.max === 1) {
                    loadMoreButton.style.display = 'none'; // Hide button if no more posts
                }

                document.querySelector('.ps-post-container').innerHTML += json_html.html; // Append new posts
                isLoading = false;
                page++; // Increment the page for the next request
            })
            .catch(error => {
                console.error('Error:', error);
                isLoading = false;
            });
        }, 300); // 300ms debounce time (adjust as needed)
    });
}
